// API URL configuration
// In production (deployed), use relative URLs
// In development (preview), use the environment variable

const getApiUrl = () => {
  // If we're on a custom domain (not emergent preview), use relative URLs
  const hostname = window.location.hostname;
  
  if (hostname.includes('preview.emergentagent.com') || hostname === 'localhost') {
    // Development/Preview - use environment variable
    return process.env.REACT_APP_BACKEND_URL || '';
  }
  
  // Production (custom domain like il-trullo.fr) - use relative URLs
  return '';
};

export const API_BASE = getApiUrl();
export const API = `${API_BASE}/api`;
